import ChartJS from "chart.js/auto"
import {
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js"
import { useSelector } from "react-redux"
import { getConf } from "../../../store/features/confSlice"
import { useEffect, useState } from "react"
import axios from "axios"
import { Line } from "react-chartjs-2"
import moment from "moment"
import "moment/locale/es"
import { Button, Grid } from "@mui/material"
import { MyDateInput } from "../../inputs/MyDateInput"
import saveAs from "file-saver"
import { getAuth } from "../../../store/features/authSlice"

/**
 * Tipo: Line
 * Detalle: Muestra el total de ingresos por cada día (últimos 15 dias)
 */

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

export const IncomeForDayChart = () => {
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [report, setReport] = useState([])
  const [reportDetail, setReportDetail] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    finishDate: moment().format("YYYY-MM-DD"),
  })
  const title = "Ingresos por día"

  useEffect(() => {
    getReport()
    getReportDetail()
  }, [filters])

  const getReport = async () => {
    try {
      const endpoint = `/report/chart/income-for-day?start-date=${filters.startDate}&finish-date=${filters.finishDate}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: auth.data.jwtToken },
      })
      setReport(data)
      console.table(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      alert("No se pudo obtener los datos del reporte")
    }
  }

  const getReportDetail = async () => {
    try {
      const endpoint = `/report/chart/income-for-day-detail?start-date=${filters.startDate}&finish-date=${filters.finishDate}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: auth.data.jwtToken },
      })
      setReportDetail(data)
      console.table(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      console.log("No se pudo obtener los datos del reporte")
    }
  }

  const handleChange = (e) => {
    const name = e.target.name
    const value = e.target.value

    console.log(name, value)

    switch (name) {
      case "startDate":
      case "finishDate":
        setFilters({ ...filters, [name]: value.substring(0, 10) })
        break
      default:
        setFilters({ ...filters, [name]: value })
    }
  }

  const download = () => {
    const title =
      "¿Que reporte desea descargar?\n\n '1': Consolidado (Total de ingresos por día)\n '2': Detallado (CPE y CIP de cada transacción aprobada)\n"
    const result = window.prompt(title, "1")

    switch (result) {
      case "1":
        downloadConsolidated()
        break
      case "2":
        downloadDetailed()
        break
      default:
      // Do nothing
    }
  }

  const downloadConsolidated = () => {
    const head = "fecha;ingresos\n"
    const body = report
      .map((item) => {
        const date = item.date
        const income = item.income
        return date + ";" + income
      })
      .join("\n")
    const file = new Blob([head + body])
    saveAs(file, `${Date.now()}.txt`)
  }

  const downloadDetailed = () => {
    const head =
      "id interno;usuario;moneda;total;id externo;método de pago;tipo CPE;serie CPE;número CPE;fecha\n"
    const body = reportDetail
      .map((item) => {
        const id = item.id
        const user = item.user
        const coin = item.coin
        const total = item.total
        const providerId = item.providerId
        const paymentMethod = item.paymentMethod
        const cpeType = item.cpeType
        const cpeSeries = item.cpeSeries
        const cpeNumber = item.cpeNumber
        const insertionDate = item.insertionDate
        return `${id};${user};${coin};${total};${providerId};${paymentMethod};${cpeType};${cpeSeries};${cpeNumber};${insertionDate}`
      })
      .join("\n")
    const file = new Blob([head + body])
    saveAs(file, `${Date.now()}.txt`)
  }

  if (isLoading) return <></>

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: title,
      },
    },
  }

  const data = {
    labels: report.map((item) => moment(item.date).format("dddd DD [de] MMMM")),
    datasets: [
      {
        label: "Total de ingresos",
        data: report.map((item) => item.income),
        borderColor: conf.data.colors.find((item) => item.id === 9).bg,
        backgroundColor: conf.data.colors.find((item) => item.id === 9).bg,
      },
    ],
  }

  return (
    <>
      <Line options={options} data={data} />
      <Grid container spacing={1} my={1}>
        <Grid item xs={4}>
          <MyDateInput
            label="Desde"
            name="startDate"
            date={filters.startDate}
            handleChangeElement={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <MyDateInput
            label="Hasta"
            name="finishDate"
            date={filters.finishDate}
            handleChangeElement={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{ height: 55 }}
            onClick={download}
          >
            Descargar
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
